// Normaliza el texto de búsqueda.
export function normQuery(value: string) {
    return value.toLowerCase();
}

// Reporta identidad faltante de la entidad.
export function missingIdentity(entity: any) {
    if (!entity) return true;
    return missingNameOrCode(entity);
}

// Reporta nombre o código faltante.
export function missingNameOrCode(entity: any) {
    if (entity.name) return !entity.code;
    return true;
}

// Compara la entidad con la consulta normalizada.
export function matchEntityText(entity: any, query: string) {
    if (matchCore(entity, query)) return true;
    if (matchRelation(entity, query)) return true;
    return matchLinks(entity, query);
}

// Compara nombre o código de la entidad.
export function matchCore(entity: any, query: string) {
    if (nameMatches(entity, query)) return true;
    return codeMatches(entity, query);
}

// Compara el nombre de la entidad.
export function nameMatches(entity: any, query: string) {
    return entity.name.toLowerCase().includes(query);
}

// Compara el código de la entidad.
export function codeMatches(entity: any, query: string) {
    return entity.code.toString().includes(query);
}

// Compara grupo u oficina de la entidad.
export function matchRelation(entity: any, query: string) {
    if (groupMatches(entity, query)) return true;
    return officeMatches(entity, query);
}

// Compara el nombre del grupo.
export function groupMatches(entity: any, query: string) {
    if (entity.group) return textMatches(entity.group.name, query);
    return false;
}

// Compara el acrónimo de la oficina.
export function officeMatches(entity: any, query: string) {
    if (entity.office) return textMatches(entity.office.acronym, query);
    return false;
}

// Compara texto en minúsculas.
export function textMatches(text: string, query: string) {
    return text.toLowerCase().includes(query);
}

// Compara los vínculos de módulos.
export function matchLinks(entity: any, query: string) {
    for (const link of (entity.entityModules || [])) {
        if (linkMatches(link, query)) return true;
    }
    return false;
}

// Compara un vínculo de módulo.
export function linkMatches(link: any, query: string) {
    if (auditorMatches(link, query)) return true;
    return moduleMatches(link, query);
}

// Compara el nombre del auditor.
export function auditorMatches(link: any, query: string) {
    if (link.auditor) return displayMatches(link.auditor.displayName, query);
    return false;
}

// Compara texto opcional.
export function displayMatches(text: any, query: string) {
    if (text) return text.toLowerCase().includes(query);
    return false;
}

// Compara el acrónimo del módulo.
export function moduleMatches(link: any, query: string) {
    if (link.module) return displayMatches(link.module.acronym, query);
    return false;
}
